// Projections over an Application's typed process-task links. The wire carries
// only `process_task_links` ({process_task_id, mode}); these helpers give the
// id-set views the UI membership checks and counts read.
import type { Application } from "@/stores/applications-store";

/** The task ids the application is linked to (link metadata dropped). */
export const linkedTaskIds = (application: Application): string[] =>
    application.process_task_links?.map((l) => l.process_task_id) ?? [];

/** Whether the application has a link to the given process task. */
export const isLinkedToTask = (
    application: Application,
    taskId: string | undefined
): boolean =>
    !!taskId &&
    !!application.process_task_links?.some((l) => l.process_task_id === taskId);
